import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {DSTStatement} from '../../shared/models/dst-statement.model';
import {ModalComponent} from '@appkit4/angular-components/modal';
import {Alert, StatementTrackerService} from '../statement-tracker.service';
import {MatchTrackerService, MatchTrackerStatement} from './match-tracker.service';
import {SaveActionResponse} from '../../../shared/_models/save-action-response.model';
import {DSTSharedService} from '../../shared/dst-shared.service';

@Component({
    selector: 'dst-match-tracker',
    templateUrl: './match-tracker.component.html',
    styleUrls: ['./match-tracker.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MatchTrackerComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


  @Input() rowObject!: DSTStatement;
  @Output() afterModalClosed: EventEmitter<null>;
  @Output() onSaveCompleted: EventEmitter<null>;

  @ViewChild('baseModal', {static: false}) baseModal!: ModalComponent;

  tableTitle: any[] = [
    {
      title: 'Action'
    },
    {
      title: 'Statement Id',
      sort: {
        sortBy: 'STATEMENT_ID',
        descendant: false,
        defaultSorted: true
      }
    },
    {
      title: 'Primary Entity',
      sort: {
        sortBy: 'PRIMARYENTITY',
      }
    },
    {
      title: 'Statement Name',
      sort: {
        sortBy: 'STATEMENTNAME',
      }
    },
    {
      title: 'Secondary Entity',
      sort: {
        sortBy: 'SECONDARYENTITY',
      }
    },
    {
      title: 'Created By',
      sort: {
        sortBy: 'CREATEDBY',
      }
    }
  ];
  tableData!: MatchTrackerStatement[];
  statementId: string = '';
  loadingStatements: boolean = false;
  saving: boolean = false;
  alert!: Alert;

  constructor(private mTService: MatchTrackerService,
              private dstSharedService: DSTSharedService) {
    this.afterModalClosed = new EventEmitter<null>();
    this.onSaveCompleted = new EventEmitter<null>();
    this.alert = this.dstSharedService.alert;
  }

  ngOnInit(): void {
    this.tableData = [];
    this.loadingStatements = true;
    this.mTService.getExistingStatements(this.rowObject.csStatementId).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: MatchTrackerStatement[]) => {
        this.tableData = data;
      }, (eMsg: string) => {
        this.dstSharedService.showAlert('error', eMsg);
      })
      .add(() => {
        this.loadingStatements = false;
      });
  }

  onStatementIdChange(event: any): void {
    this.statementId = event.value;
  }

  matchTo(row: MatchTrackerStatement): void {
    this.save(row.STATEMENT_ID.toString());
  }

  save(matchToStatementId?: string): void {
    const statementId: string = matchToStatementId ? matchToStatementId : this.statementId;
    this.saving = true;
    this.mTService.save(this.rowObject.csStatementId, statementId).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: SaveActionResponse) => {
        if (response.callSuccess === '1') {
          this.dstSharedService.showAlert('success', 'Statement matched successfully!', 4000);
          this.modalDetermine();
          this.onSaveCompleted.emit();
        } else {
          this.dstSharedService.showAlert('error', response.errorMessage);
        }
      })
      .add(() => {
        this.saving = false;
      });
  }

  showMore(id: string): void {
    this.baseModal.showModal(id);
  }

  modalClose(): void {
    this.notifyAfterModalClosed();
  }

  modalDetermine(): void {
    this.notifyAfterModalClosed();
  }

  // closeModal(id: string): void {
  //   this.baseModal.closeModal(id);
  //   this.notifyAfterModalClosed();
  // }

  closeModalOk(id: string): void {
    this.baseModal.closeModalOk(id);
    this.notifyAfterModalClosed();
  }

  private notifyAfterModalClosed(): void {
    this.afterModalClosed.emit();
  }

}

